module.exports = __webpack_public_path__ + "img/cart.cf2c2677.svg";